import { createElement } from "utils/dom/create-element";

const CACHE = new Map<string, Promise<void>>();

export async function loadScript(src: string, { defer = 0, timeout = 0 } = {}) {
  let script = CACHE.get(src);

  if (!script) {
    if (defer) {
      // Defer script loading to reduce impact on initial page load
      await new Promise((resolve) => setTimeout(resolve, defer));
      script = CACHE.get(src);
    }

    if (!script) {
      script = new Promise((resolve, reject) => {
        const scriptElement = createElement("script", { src });

        scriptElement.addEventListener("error", () => {
          reject(new Error(`${src} triggered error event during load`));
        });

        scriptElement.addEventListener("load", () => {
          resolve();
        });

        document.body.appendChild(scriptElement);
      });

      CACHE.set(src, script);
    }
  }

  if (!timeout) {
    await script;
    return;
  }

  let timeoutId: number;

  await Promise.race([
    script.then(() => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    }),
    new Promise<void>((_resolve, reject) => {
      timeoutId = window.setTimeout(() => {
        reject(new Error(`${src} loading has timed out (${timeout / 1000}s)`));
      }, timeout);
    }),
  ]);
}
